import { ApolloLink } from '@apollo/client';
import { removeKeyRecursively } from '@seek/ca-myprofile-utils';

import { isMutation } from './is-mutation';

export const removeTypeNameLink = new ApolloLink((operation, forward) => {
  if (isMutation({ operation })) {
    operation.variables = removeKeyRecursively(
      operation.variables,
      '__typename',
    );
  }
  return forward(operation);
});
